import dataCheck from "./checkStringValidation";
const { changePaymentMethod, changeBankCode, dataTrim, deleteString, changeCashReptType } = dataCheck;

export default class DataMigrationCMSInfo {

    _items = [];
    _itemNames = {};
    _data = [];
    _keyOfKrDefault = [];
    _keyOfkr = [];
    _keysOfEn = [];
    _failedItems = [];
    _type = null;

    _keyOfKrDefaultHyosung = ['', '회원번호', '회원명', '연락처', '우편번호', '주소', '약정일', '기본금액', '결제시작일', '결제종료일', '회원상태',
        '결제수단', '결제번호', '회원구분', '관리자', '인증여부', '현금영수증발행대상', '현금영수증발행정보', '등록일', '결제정보등록일', '결제자명', 'SMS발송대상']
    _keyOfkrHyosung = ['회원명', '결제수단', '회원번호', '결제자명', '결제번호', '결제번호', '약정일', '회원상태', '현금영수증발행대상', '현금영수증발행정보', 'SMS발송대상']
    _keyOfEnHyosung = ['accountName', 'payMethod', 'cmsId', 'csName', 'bankCd', 'payNumber', 'billDay', 'resultYn', 'cashReptType', 'cashReptNo', 'smsYn'];


    /**
     * 출금번호는 '구분'의 종류에 따라 accNo(계좌번호), cardNo(카드번호)로 분기해줘야 함
     * 상태 : 등록중: "R", 등록성공: "Y", 등록실패: "N"
     */
    _keyOfKrDefaultNice = ['','구분', '등록일', '회원아이디', '주민번호앞6자리/사업자번호', '회원명', '회원구분정보1', '회원구분정보2', '상품명', '예금주',
        '출금기관', '출금번호', '출금액', '약정일', '납부/약정횟수', '요청횟수', '납부시작월', '마지막출금일', '상태', '비고',
        '사업자번호', '상호', '대표자', '업태', '업종', '주소', '휴대폰번호']
    _keyOfkrNice = ['회원명', '구분', '회원아이디', '주민번호앞6자리/사업자번호', '예금주', '출금기관', '출금번호', '약정일', '상태'];
    _keyOfEnNice = ['accountName', 'payMethod', 'cmsId', 'accBizNo', 'csName', 'bankCd', 'payNumber', 'billDay', 'resultYn'];

    constructor(arr, type) {
        this._data = arr;
        this._type = type;
        this._keyOfKrDefault = type === 'H' ? this._keyOfKrDefaultHyosung : this._keyOfKrDefaultNice;
        this._keyOfkr = type === 'H' ? this._keyOfkrHyosung : this._keyOfkrNice;
        this._keysOfEn = type === 'H' ? this._keyOfEnHyosung: this._keyOfEnNice;
    }

    get items(){
        return this._items;
    }

    get itemNames(){
        return this._itemNames;
    }

    set failedItems(arr){
        this._failedItems = arr;
    }

    countName(name, idx){
        if(this._itemNames[name]){
            this._itemNames[name].count += 1;
        } else {
            this._itemNames[name] = {};
            this._itemNames[name].count = 1;
            this._itemNames[name].firstIdx = idx;
        }
    }


    niceInit(){
        this._itemNames = {};
        this._items = this._data.map((d, idx) => {
            const item = {};
            this.countName(dataTrim(d['회원명']), idx);
            this._keysOfEn.map((k, idx) => {

                // 은행 & 카드 기호로 바꿈
                if(k === 'payMethod'){
                    item[k] = changePaymentMethod(dataTrim(d[this._keyOfkr[idx]]));

                // 출금기관
                } else if(k === 'bankCd'){
                    item[k] = changeBankCode(dataTrim(d[this._keyOfkr[idx]]));

                // 결제일
                } else if(k === 'billDay'){
                    item[k] = deleteString(dataTrim(d[this._keyOfkr[idx]]));

                // 출금번호 분기
                } else if(k === 'payNumber'){
                    if(item['payMethod'] === 'B'){
                        item['accNo'] = dataTrim(d[this._keyOfkr[idx]]) || null;
                    } else {
                        item['cardNo'] = dataTrim(d[this._keyOfkr[idx]]) || null;
                    }

                // 상태 분기
                } else if(k === 'resultYn'){
                    const result = dataTrim(d[this._keyOfkr[idx]])?.split(' ')[0];
                    switch (result) {
                        case '등록중':
                            item['resultYn'] = 'R';
                            break;
                        case '등록성공':
                            item['resultYn'] = 'Y';
                            break;
                        case '정상처리':
                            item['resultYn'] = 'Y';
                            break;
                        case '등록실패':
                            item['resultYn'] = 'N';
                            break;
                        default:
                            item['resultYn'] = null;
                            break;
                    }

                } else {
                    item[k] = dataTrim(d[this._keyOfkr[idx]]) || null;
                }

            })

            return item;
        })

        return this._items;
    }

   // ['accountName', 'payMethod', 'cmsId', 'csName', 'bankCd', 'payNumber', 'billDay', 'resultYn', 'cashReptType', 'cashReptNo', 'smsYn'];
    hyosungInit(){
        this._itemNames = {};
        this._items = this._data.map((d, idx) => {
            const item = {};
            this.countName(dataTrim(d['회원명']), idx);
            this._keysOfEn.map((k, idx) => {

                // 은행 & 카드 기호로 바꿈
                if(k === 'payMethod'){
                    item[k] = changePaymentMethod(dataTrim(d[this._keyOfkr[idx]]));

                    // 결제자명
                } else if(k === 'csName'){
                    if(item['payMethod'] === 'C'){
                        item[k] = item['accountName']
                    } else {
                        item[k] = dataTrim(d[this._keyOfkr[idx]]) || null;
                    }

                    // 출금기관
                } else if(k === 'bankCd'){
                    const data = d[this._keyOfkr[idx]]?.split('(')[1]?.split(')')[0];
                    item[k] = changeBankCode(dataTrim(data));

                    // 결제일
                } else if(k === 'billDay'){
                    item[k] = deleteString(dataTrim(d[this._keyOfkr[idx]]));

                    // 출금번호 분기
                } else if(k === 'payNumber'){
                    const data = d[this._keyOfkr[idx]]?.split('(')[0]
                    if(item['payMethod'] === 'B'){
                        item['accNo'] = dataTrim(data) || null;
                    } else {
                        item['cardNo'] = dataTrim(data) || null;
                    }

                    // 상태 분기
                } else if(k === 'resultYn'){
                    const result = dataTrim(d[this._keyOfkr[idx]]);
                    switch (result) {
                        case '신청대기':
                            item['resultYn'] = 'R';
                            break;
                        case '신청완료':
                            item['resultYn'] = 'Y';
                            break;
                        default:
                            item['resultYn'] = 'delete';
                            break;
                    }

                    // 현금영수증 분기
                } else if(k === 'cashReptType'){
                    item[k] = changeCashReptType(dataTrim(d[this._keyOfkr[idx]]));

                    // sms 발송대상 분기
                } else if(k === 'smsYn'){
                    const result = dataTrim(d[this._keyOfkr[idx]]);
                    switch (result) {
                        case '대상':
                            item['smsYn'] = 'Y';
                            break;
                        default:
                            item['smsYn'] = 'N';
                            break;
                    }

                } else {
                    item[k] = dataTrim(d[this._keyOfkr[idx]]) || null;
                }

            })

            return item;
        })

        return this._items;
    }


    // ['accountId', 'cmsId', 'csName', 'csHp', 'billDay', 'contractFee', 'resultYn', 'payMethod', 'payNumber', 'cashReptType', 'cashReptNo', 'smsYn']
    onlyCmsHyosungInit(){
        this._itemNames = {};
        this._items = this._data.map((d, idx) => {
            const item = {};
            this.countName(dataTrim(d['회원명']), idx);
            this._keysOfEn.map((k, idx) => {

                  // 은행 & 카드 기호로 바꿈
                if(k === 'payMethod'){
                    item[k] = changePaymentMethod(dataTrim(d[this._keyOfkr[idx]]));

                    // 거래처번호
                } else if(k === 'accountId' || k === 'contractFee'){
                    item[k] = parseInt(deleteString(dataTrim(d[this._keyOfkr[idx]]))) || 0;

                    // 출금기관
                } else if(k === 'bankCd'){
                    const data = d[this._keyOfkr[idx]]?.split('(')[1]?.split(')')[0];
                    item[k] = changeBankCode(dataTrim(data)) || null;

                    // 결제일
                } else if(k === 'billDay'){
                    item[k] = parseInt(deleteString(dataTrim(d[this._keyOfkr[idx]]))) || 1;

                    // 연락처
                } else if(k === 'csHp'){
                    item[k] = deleteString(dataTrim(d[this._keyOfkr[idx]]));

                    // 출금번호 분기
                } else if(k === 'payNumber'){
                    const data = d[this._keyOfkr[idx]]?.split('(')[0]
                    if(item['payMethod'] === 'B'){
                        item['accNo'] = dataTrim(data) || null;
                    } else {
                        item['cardNo'] = dataTrim(data) || null;
                    }

                    // 상태 분기
                } else if(k === 'resultYn'){
                    const result = dataTrim(d[this._keyOfkr[idx]]);
                    switch (result) {
                        case '신청대기':
                            item['resultYn'] = 'R';
                            break;
                        case '신청완료':
                            item['resultYn'] = 'Y';
                            break;
                        default:
                            item['resultYn'] = null;
                            break;
                    }

                    // 현금영수증 분기
                } else if(k === 'cashReptType'){
                    item[k] = changeCashReptType(dataTrim(d[this._keyOfkr[idx]]));

                    // sms 발송대상 분기
                } else if(k === 'smsYn'){
                    const result = dataTrim(d[this._keyOfkr[idx]]);
                    switch (result) {
                        case '대상':
                            item['smsYn'] = 'Y';
                            break;
                        default:
                            item['smsYn'] = 'N';
                            break;
                    }

                } else {
                    item[k] = dataTrim(d[this._keyOfkr[idx]]) || null;
                }

            })

            return item;
        })

        return this._items;
    }


    onlyNiceInit(){
        this._itemNames = {};
        this._items = this._data.map((d, idx) => {
            const item = {};
            this.countName(dataTrim(d['회원명']), idx);
            this._keysOfEn.map((k, idx) => {

                // 은행 & 카드 기호로 바꿈
                if(k === 'payMethod'){
                    item[k] = changePaymentMethod(dataTrim(d[this._keyOfkr[idx]])) || null;


                    // 거래처번호
                } else if(k === 'accountId' || k === 'contractFee'){
                    item[k] = parseInt(deleteString(dataTrim(d[this._keyOfkr[idx]]))) || 0;

                    // 출금기관
                } else if(k === 'bankCd'){
                    item[k] = changeBankCode(dataTrim(d[this._keyOfkr[idx]]));

                    // 결제일
                } else if(k === 'billDay'){
                    item[k] = parseInt(deleteString(dataTrim(d[this._keyOfkr[idx]]))) || 1;



                    // 연락처
                } else if(k === 'cmsId'){
                    item[k] = dataTrim(d[this._keyOfkr[idx]]) || null;
                    

                    // 연락처
                } else if(k === 'csHp'){
                    item[k] = deleteString(dataTrim(d[this._keyOfkr[idx]]));

                    // 출금번호 분기
                } else if(k === 'payNumber'){
                    if(item['payMethod'] === 'B'){
                        item['accNo'] = dataTrim(d[this._keyOfkr[idx]]) || null;
                        item['cardNo']= null;
                    } else {
                        item['cardNo'] = dataTrim(d[this._keyOfkr[idx]]) || null;
                        item['accNo'] = null;
                    }

                    // 상태 분기
                } else if(k === 'resultYn'){
                    const result = dataTrim(d[this._keyOfkr[idx]])?.split(' ')[0];
                    switch (result) {
                        case '등록중':
                            item['resultYn'] = 'R';
                            break;
                        case '등록성공':
                            item['resultYn'] = 'Y';
                            break;
                        case '정상처리':
                            item['resultYn'] = 'Y';
                            break;
                        default:
                            item['resultYn'] = null;
                            break;
                    }

                } else {
                    item[k] = dataTrim(d[this._keyOfkr[idx]]) || null;
                }

            })

            return item;
        })

        console.log('!!!!! this._items : ', this._items)

        return this._items;
    }


    init(){
        if(this._type === 'H'){
            this.hyosungInit();
        } else {
            this.niceInit();
        }
    }

    onlyCmsInfoInit(){
        if(this._type === 'H'){
            this._keyOfKrDefault = ['거래처번호', '회원번호', '회원명', '연락처', '우편번호', '주소', '약정일', '기본금액', '결제시작일', '결제종료일', '회원상태',
                '결제수단', '결제번호', '회원구분', '관리자', '인증여부', '현금영수증발행대상', '현금영수증발행정보', '등록일', '결제정보등록일', '결제자명', 'SMS발송대상'];
            this._keyOfkr = ['결제수단', '거래처번호', '회원번호', '회원명', '연락처','약정일', '기본금액', '회원상태',  '결제번호', '결제번호','현금영수증발행대상', '현금영수증발행정보','SMS발송대상'];
            this._keysOfEn = ['payMethod','accountId', 'cmsId', 'csName', 'csHp', 'billDay', 'contractFee', 'resultYn', 'bankCd',  'payNumber', 'cashReptType', 'cashReptNo', 'smsYn'];
            this.onlyCmsHyosungInit()

        } else {
            this._keyOfKrDefault = ['거래처번호','구분', '등록일', '회원아이디', '주민번호앞6자리/사업자번호', '회원명', '회원구분정보1', '회원구분정보2', '상품명', '예금주',
                '출금기관', '출금번호', '출금액', '약정일', '납부/약정횟수', '요청횟수', '납부시작월', '마지막출금일', '상태', '비고',
                '사업자번호', '상호', '대표자', '업태', '업종', '주소', '휴대폰번호']
            this._keyOfkr =['거래처번호', '회원명', '구분', '회원아이디', '주민번호앞6자리/사업자번호', '상품명', '출금기관', '출금번호', '약정일', '상태', '출금액', '휴대폰번호'];
            this._keysOfEn = ['accountId', 'csName', 'payMethod', 'cmsId', 'accBizNo', 'prdName', 'bankCd','payNumber', 'billDay', 'resultYn','contractFee', 'csHp'];

            this.onlyNiceInit();
        }
    }



    dataToArray(){
        const arr = []

        this._data.map(d => {
           if(!this._itemNames[dataTrim(d['회원명'])].check){
                arr.push(Object.values(d));
            }
        })
        arr.unshift(this._keyOfKrDefault);

        return arr;
    }

}